module.exports = __webpack_public_path__ + "img/slider2.9a0a71b4.jpg";